import {
  Truck, Pill, Wallet, Boxes, CalendarDays, Megaphone, FileText, HeartHandshake,
  ShieldCheck, GraduationCap, Activity, HeartPulse,
} from "lucide-react";

// The 12 CAREIQ productivity modules, launchable from the Command Center.
// `roles` lists which roles may launch the module. admin & executive always see all.
export const MODULES = [
  { n: 1, title: "CAREIQ Fleet Operations Platform", to: "/fleet", icon: Truck, color: "#155EEF",
    desc: "Optimize routes, track vehicles, ensure safety and compliance.",
    roles: ["program_manager", "technician"] },
  { n: 2, title: "CAREIQ Medication Administration", to: "/medications", icon: Pill, color: "#F04438",
    desc: "Safe medication management, eMAR, MAP compliance.",
    roles: ["program_manager", "nurse", "dsp", "clinician"] },
  { n: 3, title: "CAREIQ Financial Platform", to: "/finance", icon: Wallet, color: "#12B76A",
    desc: "Financial planning, budgeting, reporting, and analytics.",
    roles: ["program_manager"] },
  { n: 4, title: "CAREIQ Asset & Resource Optimization", to: "/assets", icon: Boxes, color: "#F79009",
    desc: "Track assets, schedule maintenance, maximize resource utilization.",
    roles: ["program_manager", "technician", "nurse"] },
  { n: 5, title: "CAREIQ Smart Staffing", to: "/staffing", icon: CalendarDays, color: "#0EA5E9",
    desc: "AI-powered scheduling, coverage optimization, and labor analytics.",
    roles: ["program_manager"] },
  { n: 6, title: "CAREIQ InsightBridge 360", to: "/insightbridge", icon: Megaphone, color: "#7C3AED",
    desc: "Unified analytics, cross-module insights, and performance intelligence.",
    roles: ["program_manager", "compliance"] },
  { n: 7, title: "CAREIQ Documentation", to: "/documents", icon: FileText, color: "#155EEF",
    desc: "Smart documentation, templates, and real-time collaboration.",
    roles: ["program_manager", "nurse", "dsp", "clinician", "compliance"] },
  { n: 8, title: "CAREIQ Family Engagement", to: "/families", icon: HeartHandshake, color: "#DB2777",
    desc: "Family portal, communications, updates, and digital forms.",
    roles: ["program_manager", "nurse", "clinician"] },
  { n: 9, title: "CAREIQ Compliance & Regulatory", to: "/compliance", icon: ShieldCheck, color: "#F79009",
    desc: "Stay audit-ready, track compliance, and manage regulatory requirements.",
    roles: ["program_manager", "compliance", "nurse"] },
  { n: 10, title: "CAREIQ Adaptive Training & Talent Intelligence", to: "/training", icon: GraduationCap, color: "#6366F1",
    desc: "Training, certifications, performance management, and career growth.",
    roles: ["program_manager", "nurse", "dsp", "clinician", "compliance"] },
  { n: 11, title: "CAREIQ Activities & Community Integration", to: "/activities", icon: Activity, color: "#12B76A",
    desc: "Plan activities, track participation, and promote community inclusion.",
    roles: ["program_manager", "nurse", "dsp", "clinician"] },
  { n: 12, title: "CAREIQ Resident Health Intelligence Platform", to: "/health", icon: HeartPulse, color: "#0EA5E9",
    desc: "Health monitoring, risk insights, and clinical intelligence.",
    roles: ["program_manager", "nurse", "clinician", "dsp"] },
];

export const ALL_ACCESS_ROLES = ["admin", "executive"];

export function modulesForRole(role) {
  if (!role || ALL_ACCESS_ROLES.includes(role)) return MODULES;
  return MODULES.filter((m) => m.roles.includes(role));
}

// Filter modules by an explicit list of allowed module numbers (from /api/access/me).
export function modulesForIds(ids) {
  if (!ids) return MODULES;
  return MODULES.filter((m) => ids.includes(m.n));
}

// Per-user recently launched modules (client-side, most-recent first, capped at 5).
const RECENT_KEY = "careiq_recent_modules";
export function recordRecentModule(n) {
  try {
    const cur = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]").filter((x) => x !== n);
    cur.unshift(n);
    localStorage.setItem(RECENT_KEY, JSON.stringify(cur.slice(0, 5)));
  } catch (e) { /* ignore */ }
}
export function getRecentModules() {
  try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch (e) { return []; }
}
